export default __webpack_public_path__ + "static/media/opensans-extrabolditalic-webfont.d3bf38fa.woff2";